export default [{
  path: '/materials',
  name: 'materials',
  redirect: {
    name: 'materials.requests',
  },
  component: {
    render(c) {
      return c('router-view');
    },
  },
  meta: {
    breadcrumb: 'Materials',
    menuOptions: {
      title: 'Materials',
    },
  },
  children: [{
      path: 'requests',
      name: 'materials.requests',
      component: () => import('@/pages/home'),
      meta: {
        breadcrumb: 'Material Requests',
      },
    }, {
      path: 'search',
      name: 'materials.search',
      component: () => import('@/components/cataloger-usr/cat4mro/search'),
      meta: {
        breadcrumb: 'Search',
      },
    },
    {
      path: 'create',
      name: 'materials.create',
      component: () => import('@/pages/home'),
      meta: {
        breadcrumb: 'Create Material',
      },
    },
    {
      path: 'catalog/:catalog/product/:item',
      name: 'material.catalog.products.item',
      props: route => ({
        product: route.params.item,
        catalog: route.params.catalog,
        query: route.params.query,
      }),
      component: () => import('@/pages/buyer/catalog/product'),
      meta: {
        breadcrumb: 'Item',
      },
    },
  ],
},
{
  path: '/catalog',
  name: 'catalog',
  redirect: {
    name: 'catalog.search',
  },
  component: {
    render(c) {
      return c('router-view');
    },
  },
  meta: {
    breadcrumb: 'Catalog',
    menuOptions: {
      title: 'Catalog',
      description: 'En esta sección podrá realizar búsquedas específicas sobre su catálogo de ítems',
    },
  },
  children: [
    {
      path: 'search',
      name: 'catalog.search',
      component: () => import('@/pages/supplier/catalog/search'),
      meta: {
        breadcrumb: 'Search',
      },
    },
    {
      path: ':item',
      name: 'catalog.products.item',
      component: () => import('@/pages/supplier/catalog/product'),
      meta: {
        breadcrumb() {
          const storeInfo = this.$store.getters['catalog/currentProductItemInfo'];
          if (!storeInfo) {
            return 'Item';
          }
          return `Item - ${storeInfo.name}`;
        },
      },
    },
  ],
}];



// WEBPACK FOOTER //
// ./src/router/routes/cataloger.js